<template>
    <router-link v-if="link" class="categoryButton" :to="{path: link}">
        <span>{{ category ? category.name : "..." }}</span>
    </router-link>
</template>

<script>
    export default {
        name: "CategoryName",
        props: {
            id: {
                default: null,
            },
            categories: {
                default: [],
            },
        },
        data() {
            return {
                currentId: null,
            }
        },
        computed: {
            category() {
                if( this.currentId == null ) {
                    return null
                }
                return this.$store.getters["categories/id"](this.currentId)
            },
            link() {
                if( this.category == null ) {
                    return ''
                }
                if( this.category.link == null ) {
                    return ''
                }
                return this.category.link
            },
        },
        watch: {
            category: {
                immediate: true,
                handler() {
                    if( this.currentId == null ) {
                        return
                    }
                    if( this.category == null ) {
                        this.$store.dispatch("categories/getById", this.currentId)
                        return
                    }
                    if( this.category.acf.not_browsable ) {
                        let found = false
                        for(let i of this.categories ) {
                            if( found ) {
                                this.currentId = i
                                break
                            }
                            found = i == this.currentId
                        }
                    }
                },
            },
            id: {
                immediate: true,
                handler() {
                    this.currentId = this.id
                },
            },
            categories: {
                immediate: true,
                handler() {
                    if( this.id != null ) {
                        return
                    }
                    if( this.currentId == null ) {
                        this.currentId = this.categories[0]
                        return
                    }
                },
            },
        },
    }
</script>

<style lang="scss" scoped>
@import "@/assets/scss/queries";
@import "@/assets/scss/colors";

.categoryButton {
    --news-meta-category-size: 0.65rem;

    display: grid;
    place-items: center;
    max-width: calc(7rem / 0.70613);
    height: calc(3.1 * var(--news-meta-category-size));
    width: calc(9.9 * var(--news-meta-category-size));
    flex-shrink: 0;

    border: 1px solid $color-betano;

    color: $color-white;
    background-color: $color-betano;
    font-family: Glober;
    font-size: var(--news-meta-category-size);
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    text-transform: uppercase;
    text-decoration: none;
    text-align: center;

    > span {
        transform: translateY(.15em);
    }
}

</style>
